import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../../../utils";
import { Text } from "../../../Text";
import { TextTypes } from "../../../constants";

import "../styles.scss";

export const InsuranceField = ({ children, className, title }) => (
  <div className={createClassNameString(["apti-CompletedProfileInsurance--field", className])}>
    <Text type={TextTypes.label}>{title}</Text>
    {children}
  </div>
);

InsuranceField.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};

InsuranceField.defaultProps = {
  children: <></>,
  className: undefined,
  title: "",
};
